import { TColor } from '@src/models/common';
import { TNotificationView } from '@src/models/props';
import { TIconName } from '../Icon';

export const TITLE_DATA: {
  [x in TNotificationView]: {
    title: string;
    icon: TIconName;
    color: TColor;
  };
} = {
  error: {
    color: 'statusErrorText',
    icon: 'circularAttention',
    title: 'Ошибка',
  },
  warning: {
    color: 'statusWarningText',
    icon: 'triangleAttention',
    title: 'Предупреждение',
  },
  success: {
    color: 'statusSuccessText',
    icon: 'circularCheck',
    title: 'Сообщение об успехе',
  },
  info: {
    color: 'statusInfoText',
    icon: 'circularAttention',
    title: 'Информационное сообщение',
  },
};
